// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_MudarStatusInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_MudarStatusInput — POST /chamados/mudar-status.
 *
 * Aqui o contrato só afirma que o status EXISTE. Se a TRANSIÇÃO é permitida
 * depende do estado atual da linha, que o contrato não conhece — essa metade
 * é do controller, via ChamadoStatus::podeIr(). Dividir assim evita a
 * tentação de o contrato ler o banco.
 */
import { registerContract } from './validate'

export interface Chamados_MudarStatusInput {
chamado_id: number
status?: string
}

registerContract('Chamados_MudarStatusInput', {
  chamado_id: { type: 'number',  required: true },
  status:     { type: 'string',  required: false },
})
